if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        this.querySelector(".quick-add-modal__overlay")?.addEventListener(
          "click",
          this.hide.bind(this, false),
        );

        //window.addEventListener('resize', function () {
        //	$('.js-media-list').each(function () {
        //		this.swiper?.destroy();
        //	});
        //	$('.js-media-sublist').each(function () {
        //		this.swiper?.destroy();
        //	});

        //	setTimeout(() => {
        //		subSliderInit(true);
        //		sliderInit(true);
        //	}, 200)
        //});
      }

      attachDropdownsListeners() {
        // Initialize accordion toggles
        document
          .querySelectorAll(".collapsible-content__toggle")
          .forEach((element) => {
            if (element.classList.contains("content_started")) {
              return;
            }
            element.classList.add("content_started");

            element.addEventListener("click", function () {
              const parent = this.parentElement;
              const itemsContainer = this.closest(
                ".collapsible-content__items",
              );
              const answer = this.nextElementSibling;

              if (!parent.classList.contains("active")) {
                // Close any sibling that is currently active
                Array.from(parent.parentElement.children).forEach((sibling) => {
                  if (
                    sibling !== parent &&
                    sibling.classList.contains("collapsible-content__item") &&
                    sibling.classList.contains("active")
                  ) {
                    sibling.classList.remove("active");
                  }
                });

                parent.classList.add("active");

                // Slide up all answers within this items container
                if (itemsContainer) {
                  itemsContainer
                    .querySelectorAll(".collapsible-content__answer")
                    .forEach((ans) => slideUp(ans, 300));
                }

                // Slide down the clicked answer
                slideDown(answer, 300);
              } else {
                parent.classList.remove("active");
                slideUp(answer, 300);
              }
            });
          });

        // Hover opacity effect on siblings
        document
          .querySelectorAll(".collapsible-content__item")
          .forEach((element) => {
            element.addEventListener("mouseenter", function () {
              this.classList.remove("collapsible-content__item--opacity");
              getSiblings(this).forEach((sibling) =>
                sibling.classList.add("collapsible-content__item--opacity"),
              );

              const onLeave = () => {
                getSiblings(this).forEach((sibling) =>
                  sibling.classList.remove(
                    "collapsible-content__item--opacity",
                  ),
                );
                this.removeEventListener("mouseleave", onLeave);
              };
              this.addEventListener("mouseleave", onLeave);
            });
          });

        // --- Helper functions ---

        function getSiblings(element) {
          return Array.from(element.parentElement.children).filter(
            (child) => child !== element,
          );
        }

        function slideDown(element, duration = 300) {
          if (!element) return;
          element.style.removeProperty("display");
          let display = window.getComputedStyle(element).display;
          if (display === "none") display = "block";
          element.style.display = display;

          const height = element.offsetHeight;
          element.style.overflow = "hidden";
          element.style.height = "0";
          element.style.paddingTop = "0";
          element.style.paddingBottom = "0";
          element.style.marginTop = "0";
          element.style.marginBottom = "0";
          element.offsetHeight; // force reflow
          element.style.transitionProperty = "height, margin, padding";
          element.style.transitionDuration = duration + "ms";
          element.style.height = height + "px";
          element.style.removeProperty("padding-top");
          element.style.removeProperty("padding-bottom");
          element.style.removeProperty("margin-top");
          element.style.removeProperty("margin-bottom");

          window.setTimeout(() => {
            element.style.removeProperty("height");
            element.style.removeProperty("overflow");
            element.style.removeProperty("transition-duration");
            element.style.removeProperty("transition-property");
          }, duration);
        }

        function slideUp(element, duration = 300) {
          if (!element) return;
          element.style.transitionProperty = "height, margin, padding";
          element.style.transitionDuration = duration + "ms";
          element.style.boxSizing = "border-box";
          element.style.height = element.offsetHeight + "px";
          element.offsetHeight; // force reflow
          element.style.overflow = "hidden";
          element.style.height = "0";
          element.style.paddingTop = "0";
          element.style.paddingBottom = "0";
          element.style.marginTop = "0";
          element.style.marginBottom = "0";

          window.setTimeout(() => {
            element.style.display = "none";
            element.style.removeProperty("height");
            element.style.removeProperty("padding-top");
            element.style.removeProperty("padding-bottom");
            element.style.removeProperty("margin-top");
            element.style.removeProperty("margin-bottom");
            element.style.removeProperty("overflow");
            element.style.removeProperty("transition-duration");
            element.style.removeProperty("transition-property");
          }, duration);
        }
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";

        $(".js-media-list").each(function () {
          this.swiper?.destroy();
        });
        $(".js-media-sublist").each(function () {
          this.swiper?.destroy();
        });

        subSliderInit(true);
        sliderInit(true);

        if (preventFocus) this.openedBy = null;
        super.hide();

        document.body.classList.remove("overflow-hidden-modal");
        //location.reload()
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            this.productElement =
              responseHTML.querySelector(".product-section");
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener,
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);

            document.body.classList.add("overflow-hidden-modal");
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            subSliderInit(true);
            sliderInit(true);

            window.initCollapsibleContent();
            document
              .querySelectorAll("button[data-info-card-url]")
              .forEach((button) => {
                button.addEventListener("click", (event) => {
                  event.preventDefault();
                  const url = button.getAttribute("data-info-card-url");
                  if (url) {
                    window.open(url, "_blank");
                  }
                });
              });
          });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML),
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        // Read more button
        const moreBtn = document.createElement("a");
        moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>
														<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path d="M3.25 9.25L6.75 5.75L3.25 2.25" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
														</svg>`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute("class", "product__full-details button");
        if (
          element.querySelectorAll(".product__info-column") &&
          element.querySelectorAll(".product__info-column").length > 0
        ) {
          element.querySelectorAll(".product__info-column").forEach((el, i) => {
            if (i === 1) {
              el.appendChild(moreBtn);
            }
          });
        } else {
          element
            .querySelector(".product__info-container")
            .appendChild(moreBtn);
        }
      }

      removeDOMElements() {
        const modal = this.productElement.querySelector("product-modal");
        if (modal) modal.remove();

        const breadcrumb = this.productElement.querySelectorAll(".breadcrumb");
        breadcrumb.forEach((el) => {
          const container = el.closest(".container");
          if (container) {
            container.remove();
          }
        });

        const popup = this.productElement.querySelectorAll(".product-popup");
        popup.forEach((el) => {
          el.remove();
        });

        const sku = this.productElement.querySelector(".product__sku");
        if (sku) sku.remove();

        const about = this.productElement.querySelectorAll(".about");
        about.forEach((el) => {
          el.remove();
        });

        const customLiquid =
          this.productElement.querySelectorAll(".custom-liquid");
        customLiquid.forEach((el) => {
          el.remove();
        });

        const shareButtons =
          this.productElement.querySelector(".share-buttons");
        if (shareButtons) shareButtons.remove();

        const tags = this.productElement.querySelector(".product-tags");
        if (tags) tags.remove();

        const pickupAvailability = this.productElement.querySelector(
          ".pickup-availability",
        );
        if (pickupAvailability) pickupAvailability.remove();
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`,
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]',
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes),
        );
      }
    },
  );
}
